import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideHttpClient } from '@angular/common/http';
import { TranslationService } from '@app/common-codes/services/TranslationService';

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch((err) => console.error(err));

//bootstrapApplication(AppComponent, {
//  providers: [
//    provideHttpClient(),
//    TranslationService // Normalement providedIn: 'root', mais au cas ou ...
//  ]
//});
